/**
 * Alarms Module - Getters
 *
 * Computed state accessors for alarm data
 */

import type { AlarmsState } from './mutations';
import type { IAlarmData } from '@/models/dtos/AlarmDTO';

export default {
  /**
   * Get all alarm history records
   * @param state - Current alarms state
   * @returns Array of historical alarm data
   */
  alarmsHistory(state: AlarmsState): IAlarmData[] {
    return state.alarmsHistory;
  },
};


